import { supabase } from '../supabaseClient';

/**
 * Verwijder niet-afgeronde (unverified) 2FA-factoren van de huidige gebruiker.
 *
 * Een afgebroken setup (dialoog gesloten, pagina herladen) laat een unverified factor
 * achter. Zonder opruimen faalt een nieuwe poging of kiest de verificatie de verkeerde factor.
 * Let op: `listFactors().data.totp` bevat alleen geverifieerde factoren; `all` bevat alles.
 */
export async function removeUnverifiedFactors() {
  const { data, error } = await supabase.auth.mfa.listFactors();
  if (error) throw error;
  const all = data?.all ?? [...(data?.totp || []), ...(data?.phone || [])];
  const unverified = all.filter((factor) => factor.status !== 'verified');
  for (const factor of unverified) {
    const { error: unenrollError } = await supabase.auth.mfa.unenroll({ factorId: factor.id });
    if (unenrollError) throw unenrollError;
  }
  return unverified.length;
}

/**
 * Unieke naam voor een nieuwe authenticator. Supabase weigert dubbele namen, ook als de
 * oude factor nooit is afgerond.
 */
export function buildFactorName(email) {
  const date = new Date().toLocaleDateString('nl-NL');
  const suffix = Math.random().toString(36).slice(2, 6);
  return `${email || 'BEM.report'} - Authenticator ${date} ${suffix}`;
}

/** Start een nieuwe TOTP-enrollment na het opruimen van eerdere, afgebroken pogingen. */
export async function enrollTotp(email) {
  await removeUnverifiedFactors();
  const { data, error } = await supabase.auth.mfa.enroll({
    factorType: 'totp',
    friendlyName: buildFactorName(email),
  });
  if (error) throw error;
  return data;
}
